module.exports = __webpack_public_path__ + "img/traffic-total.5c18b786.svg";